import { FC, SVGProps } from "react";

export const ClockIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg width='20' height='21' viewBox='0 0 20 21' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
		<path
			fillRule='evenodd'
			clipRule='evenodd'
			d='M3.38235 10.5C3.38235 6.84517 6.34517 3.88235 10 3.88235C13.6548 3.88235 16.6176 6.84517 16.6176 10.5C16.6176 14.1548 13.6548 17.1176 10 17.1176C6.34517 17.1176 3.38235 14.1548 3.38235 10.5ZM10 3C5.85786 3 2.5 6.35786 2.5 10.5C2.5 14.6421 5.85786 18 10 18C14.1421 18 17.5 14.6421 17.5 10.5C17.5 6.35786 14.1421 3 10 3ZM10.2273 7.77679C10.2273 7.55489 10.0365 7.375 9.80114 7.375C9.56579 7.375 9.375 7.55489 9.375 7.77679V10.7438C9.375 10.8604 9.42875 10.9713 9.52228 11.0476L11.795 12.902C11.973 13.0472 12.2421 13.0289 12.3961 12.8611C12.5501 12.6933 12.5307 12.4396 12.3527 12.2944L10.2273 10.5602V7.77679Z'
			fill='currentColor'
		/>
	</svg>
);
